import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {UpdateCertificationDocumentPage} from "./update-certification-document";

import {IonicSelectableModule} from 'ionic-selectable';

import {BrMaskerModule} from 'brmasker-ionic-3';
import {FileUploadModule} from 'ng2-file-upload';

@NgModule({
  declarations: [
    UpdateCertificationDocumentPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateCertificationDocumentPage),
    IonicSelectableModule,
    BrMaskerModule,
    FileUploadModule,
  ],
  exports: [
    UpdateCertificationDocumentPage
  ]
})
export class UpdateCertificationDocumentPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/update-certification-document/update-certification-document.module.ts